<template>
    <el-dialog title="添加意向城市" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-identify">
        <img src="../assets/images/close.png" alt="关闭" @click="closeHandler">
        <el-row>
            <el-col :span="6">
                <el-scrollbar wrap-class="vertical_scrollbar">
                    <a  @click="changePro('#pro' + key, key)" v-for="(item, key) in province_options" :key="key" :class="['item-view', active_pro === key ? 'acitve-item' : '']">
                        {{ item }}
                    </a>
                </el-scrollbar>
            </el-col>
            <el-col :span="18">
                <el-scrollbar wrap-class="vertical_scrollbar" id="scrollView" ref="scroll">
                    <div :id="'pro' + key" v-for="(item, key) in city_options" :key="key">
                        <div class="provice-view">{{ province_options[key] }}</div>
                        <div v-for="(item1, key1) in item" :key="key1" class="item-view" @click="selectCity(key, key1)">
                            {{ item1.name }}
                            <img v-if="!item1.checked" src="@/assets/images/select_icon1.png">
                            <img v-else src="@/assets/images/select_icon2.png">
                        </div>
                    </div>
                </el-scrollbar>
            </el-col>
        </el-row>
        <div class="flex">
            <el-popover
                placement="top"
                popper-class="popper-view"
                trigger="click"
                :visible-arrow="false"
                @hide="show_data=false"
            >
                <el-table :data="city_arr">
                    <el-table-column prop="name" min-width="200"></el-table-column>
                    <el-table-column width="100" align="right">
                        <template slot-scope="scope">
                            <div class="remove-btn" @click="removeCity(scope.row, scope.$index)">移除</div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="add-count" slot="reference" @click="show_data=!show_data">已添加：<span>{{ city_ids.length }}</span>/8<i v-if="!show_data" class="el-icon-arrow-down"></i><i v-else class="el-icon-arrow-up"></i></div>
            </el-popover>
            <div>
                <el-button @click="closeHandler">取消</el-button>
                <el-button class="save-btn" @click="addCity">保存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { getCityList } from '@/api/user'
export default {
    name: 'IntentionCity',
    props: ['cityList'],
    data() {
        return {
            city_options: {},
            province_options: {},
            active_pro: '',
            top_list: [],
            click_status: false,
            select_city: [],
            city_ids: [],
            city_arr: [],
            show_data: false
        }
    },
    mounted() {
        this.select_city = [...this.cityList]
        this.getCityList()
    },
    methods: {
        closeHandler() {
            this.$store.commit('user/SHOWINTENTIONCITY', false)
        },
        // 获取城市列表
        getCityList() {
            const that = this
            getCityList().then(res => {
                this.active_pro = res.data[0].name
                res.data.map((item,index) => {
                    this.province_options[item.name] = item.name
                    this.city_options[item.name] = []
                    item.citys.map((item1, index1) => {
                        const tmp = this.select_city.findIndex(val => { return val[1] === item1.name })
                        if(tmp > -1) {
                            item1.checked = true
                            this.city_ids.push(item1.name)
                            this.city_arr.push({
                                province: item.name,
                                name: item1.name
                            })
                        } else {
                            item1.checked = false
                        }
                        this.city_options[item.name].push(item1)
                    })
                })
                this.$forceUpdate()
                res.data.map((item,index) => {
                    that.$nextTick(()=> {
                        const div = 'pro' + item.name
                        const tmp = {
                            name: item.name,
                            top: document.getElementById(div).offsetTop
                        }
                        that.top_list.push(tmp)
                    })
                })
                document.getElementById('scrollView').addEventListener('scroll', that.scrollView, true)
            })
        },
        // 滚动
        scrollView() {
            if(this.click_status) {
                return
            }
            let top = this.$refs.scroll.$refs.wrap.scrollTop
            this.top_list.map((item, index) => {
                if(top >= item.top) {
                    this.active_pro = this.top_list[index].name
                    return
                }
            })
            
        },
        // 省份切换
        changePro(div, key) {
            const that = this
            that.click_status = true
            document.getElementById('scrollView').removeEventListener('scroll', that.scrollView)
            that.active_pro = key
            window.location.href = div
            setTimeout(() => {
                that.click_status = false
            }, 100)
        },
        // 城市切换
        selectCity(key, key1) {
            const data = this.city_options[key][key1]
            this.$forceUpdate()
            const index_tmp = this.city_ids.indexOf(data.name)
            if(index_tmp === -1) {
                if(this.city_ids.length > 7) {
                    return
                }
                data.checked = true
                this.city_ids.push(data.name)
                this.city_arr.push({
                    province: key,
                    name: data.name
                })
                const arr = []
                arr[0] = this.province_options[key]
                arr[1] = this.city_options[key][key1].name
                this.select_city.push(arr)
            } else {
                data.checked = false
                this.city_ids.splice(index_tmp, 1)
                this.select_city.splice(index_tmp, 1)
                this.city_arr.splice(index_tmp, 1)
            }
        },
        // 城市提交
        addCity() {
            this.$emit('update', this.select_city)
            this.closeHandler()
        },
        // 移除城市
        removeCity(data, index) {
            const pro_tmp = this.city_arr[index]
            const city_tmp = this.city_options[pro_tmp.province]
            const index_tmp = city_tmp.findIndex(val => { return val.name === data.name })
            this.city_options[pro_tmp.province][index_tmp].checked = false
            this.city_ids.splice(index, 1)
            this.select_city.splice(index, 1)
            this.city_arr.splice(index, 1)
        }
    }
}
</script>

<style lang='scss' scoped>
@import "@/assets/css/variables.scss";
.dialog-box {
    ::v-deep .el-dialog {
        height: 600px;
        width: 720px;
        .vertical_scrollbar {
            overflow-x: hidden;
            height: 402px;
            padding-bottom: 20px;
        }
        .el-button {
            width: 100px!important;
            height: 44px!important;
            background: #ffffff!important;
            border: 1px solid #c4c7cc!important;
            border-radius: 8px;
            color: #5e6166!important;
            font-size: 16px;
        }
        .save-btn {
            background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
            border: none!important;
            color: #ffffff!important;
        }
    }
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
        z-index: 999;
    }
    .el-col-6 {
        padding-right: 18px;
        border-right: 1px solid #e1e4eb;
    }
    .item-view {
        padding: 12px 0;
        border-bottom: 1px solid #e1e4eb;
        font-size: 14px;
        color: #5e6166;
        line-height: 20px;
        cursor: default;
        display: block;
        text-decoration: none;
        position: relative;
    }
    .acitve-item {
        color: #ff6524;
    }
    .provice-view {
        color: #999390;
        margin-top: 12px;
    }
    .el-col-18 {
        padding-left: 16px;
        .item-view {
            color: #2c2e33;
            padding: 12px 0;
            img {
                position: absolute;
                right: 0;
                top: 15px;
                width: 20px;
                height: 20px;
            }
        }
    }
    .flex {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .add-count {
            font-size: 14px;
            span {
                color: #ff6524;
            }
        }
    }
}
.remove-btn {
    color: #ff6524;
    cursor: pointer;
}
.el-icon-arrow-down {
    color: #c4c7cc;
    font-size: 14px;
    margin-left: 6px;
    position: relative;
    top: 2px;
}
.el-icon-arrow-up {
    color: #ff6524;
    font-size: 14px;
    margin-left: 6px;
    position: relative;
}
</style>